import { css } from 'linaria';

export const serviceDescription = css`
  margin-top: 24px;
  
  @media (--only-tablet) {
    margin-top: 8px;
  }
  
  @media (--only-mobile) {
    margin-top: 0;
  }
`;

export const serviceDescriptionHeader = css`
  width: 515px;
  margin-bottom: 16px;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const serviceDescriptionList = css`
  padding: 0;
  margin: 0 0 20px;
  list-style: none;

  li:not(:last-child) {
    margin-bottom: 10px;
  
    @media (--only-tablet) {
      margin-bottom: 12px;
    }
  }
`;

export const serviceDescriptionItem = css`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;
